import { IntentCard, Intents } from '../types/intent';
import Colors from '../utils/color';

export const INTENT_CARDS: IntentCard[] = [
  {
    intent: Intents.greet,
    title: 'Welcome',
    description: 'Start of order interaction (or) follow-up greeting',
    color: Colors.acknowledge,
    textColor: Colors.primaryButtonTextColor,
    cardSize: 4,
    messages: [
      'Hi, what can I make fresh for you today?',
      'What can I start you off with today?',
      'Welcome! What would you like to order?',
      'Hi, what sounds good today?',
      'Welcome, are you ready to place your order?',
      'Hello, what are we having today?',
      'What would make your day delicious?',
    ],
  },
  {
    intent: Intents.acknowledge,
    title: 'Okay',
    description: 'Acknowledgment (or) affirmation',
    color: Colors.askRepeat,
    textColor: Colors.white,
    cardSize: 4,
    messages: [
      'Sure',
      'Got it',
      'Great',
      'Alright',
      'Certainly',
      'Sounds good',
      "Okay, I've got it",
      'Of course',
      'Sure thing',
      'Absolutely',
    ],
  },
  {
    intent: Intents.askRepeat,
    title: 'Say Again',
    description: 'Request customer to repeat',
    color: Colors.acknowledge,
    textColor: Colors.primaryButtonTextColor,
    cardSize: 4,
    messages: [
      'Could you say that again, please?',
      "Sorry, I didn't catch that. Could you repeat that one more time, please?",
      'Could you repeat that, please?',
      'I missed that. Could you repeat it, please?',
      "I'm sorry, could you say that one more time?",
      'Would you mind repeating that?',
    ],
  },
  {
    intent: Intents.askMoment,
    title: 'Moment',
    description: 'Request brief pause',
    color: Colors.askRepeat,
    textColor: Colors.white,
    cardSize: 4,
    messages: [
      'One second please, let me check that.',
      'Just a moment, please.',
      'Please give me a moment to confirm that.',
      'One moment while I look into that for you.',
      'Let me check that for you.',
    ],
  },
  {
    intent: Intents.requestStaff,
    title: 'Request Staff',
    description: 'Escalation to restaurant staff',
    color: Colors.requestStaff,
    textColor: Colors.white,
    disabled: true,
    cardSize: 4,
    messages: [
      "One moment please, I'll bring in a team member to help you.",
      'Just a second, let me get someone who can help you right away.',
      'Let me get a team member to help you out.',
      'Give me a moment while I get someone to help you.',
      "To best assist you, I'm bringing in someone from the team",
    ],
  },
  {
    intent: Intents.continue,
    title: 'Continue',
    description: 'Prompt to continue or add items',
    color: Colors.askRepeat,
    textColor: Colors.white,
    cardSize: 4,
    messages: [
      'What else can I get for you?',
      'What would you like next?',
      'What else would you like to add?',
      "What's next for your order?",
      'What else are we adding today?',
      'What can I make for you next?',
    ],
  },
  {
    intent: Intents.confirm,
    title: 'Confirm',
    description: 'Confirm if order is complete (or) end of order',
    color: Colors.acknowledge,
    textColor: Colors.primaryButtonTextColor,
    cardSize: 4,
    messages: [
      'Anything else for you today?',
      'Is that everything for now?',
      'Would that be all for you today?',
      'Is that all?',
    ],
  },
  {
    intent: Intents.readback,
    title: 'Read Back',
    description: 'Provide order readback',
    color: Colors.askRepeat,
    textColor: Colors.white,
    cardSize: 4,
    messages: ['Does your order look correct on the screen?'],
  },
  {
    intent: Intents.complete,
    title: 'Complete',
    description: 'State total and direct to drive forward',
    color: Colors.acknowledge,
    textColor: Colors.primaryButtonTextColor,
    cardSize: 4,
    messages: [
      '{total}. Thank you! Please pull forward to the window.',
      '{total}. Thank you! Please drive forward.',
      "{total}. Thank you! You're all set. Please go ahead and pull up.",
    ],
  },
];
